import ErrorViewSelector from 'components/errorViewSelector/ErrorViewSelector';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import HeaderText from 'components/headerText/HeaderText';
import ProgressBar from 'components/progressBar/ProgressBar';
import Spinner from 'components/spinner/Spinner';
import Statusbar from 'components/statusbar/Statusbar';
import StatusbarMobile from 'components/statusbarMobile/StatusbarMobile';
import React, { Component } from 'react';
import { PaymentPartial } from 'types/Payment';

import {
  Container,
  Content,
  HeaderTextWrapper,
  Main,
  MainWrapper,
  PaymentNotificationSpinnerContainer,
  Section,
  Wrapper,
} from './CommonLayout.styles';
import { ICommonLayoutProps, ICommonLayoutState } from './CommonLayout.types';
import RedirectNotification from '../redirect/notification/RedirectNotification';
import TopPaymentNotificationMobile from '../topPaymentNotificationMobile/TopPaymentNotificationMobile';
import getRouteWithParams from '../../helpers/getRouteWithParams';

class CommonLayout extends Component<ICommonLayoutProps & Partial<IContext>, ICommonLayoutState> {
  constructor(props) {
    super(props);
    this.state = {
      paymentDetails: {},
      paymentId: '',
      shouldShowPaymentRedirectScreen: false,
    };
  }

  setPaymentDetails = (paymentDetails: PaymentPartial, paymentId: string) => {
    this.setState({ paymentDetails, paymentId });
  };

  isEmpty = (obj: object) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return false;
      }
    }
    return true;
  };

  showPaymentRedirectScreen = () => {
    this.setState(() => ({ shouldShowPaymentRedirectScreen: true }));
  };

  getRedirectUrl = () => {
    const { paymentDetails, paymentId } = this.state;
    if (paymentDetails && paymentId) {
      const customQueryParams = { paymentId, paymentStatus: paymentDetails.status };
      return getRouteWithParams(paymentDetails.continueUrl as string, customQueryParams);
    }
    return undefined;
  };

  render() {
    const { render, error } = this.props;
    const { paymentDetails, paymentId, shouldShowPaymentRedirectScreen } = this.state;
    const hasPaymentDetails = !this.isEmpty(paymentDetails);
    const hasNoError = !error;

    return (
      <>
        <Wrapper className="app__wrapper">
          <Container className="app__container">
            {hasNoError && (
              <Header
                continueUrl={this.getRedirectUrl()}
                returnToShopEnabled={paymentDetails.returnToShopEnabled as boolean}
              />
            )}
            <Section>
              <Main className="app__main">
                <MainWrapper>
                  {hasPaymentDetails && paymentId && (
                    <HeaderTextWrapper>
                      <HeaderText paymentId={paymentId} />
                    </HeaderTextWrapper>
                  )}
                  <Content fillContent={!!paymentId}>
                    {hasNoError &&
                      (hasPaymentDetails ? (
                        <TopPaymentNotificationMobile payment={paymentDetails} />
                      ) : (
                        <Spinner isLoading />
                      ))}
                    {hasNoError && (hasPaymentDetails ? <ProgressBar /> : <Spinner isLoading />)}
                    {hasNoError ? render(this.setPaymentDetails) : <ErrorViewSelector {...error} />}
                  </Content>
                </MainWrapper>
              </Main>
              {hasNoError && (
                <Statusbar
                  {...{
                    payment: paymentDetails,
                    paymentId,
                    showPaymentRedirectScreen: this.showPaymentRedirectScreen,
                  }}
                />
              )}
            </Section>
            <Footer />
          </Container>
          <PaymentNotificationSpinnerContainer
            isDisplayed={shouldShowPaymentRedirectScreen}
            className="paymentNotificationSpinner__container"
          >
            <RedirectNotification type="psd2" />
          </PaymentNotificationSpinnerContainer>
        </Wrapper>
        <StatusbarMobile
          payment={paymentDetails}
          paymentId={paymentId}
          showPaymentRedirectScreen={this.showPaymentRedirectScreen}
        />
      </>
    );
  }
}

export default CommonLayout;
